export function formatTime(timeString) {
  if(!timeString) return null
  const [hourStr, minuteStr] = timeString.split(':');
  let hours = parseInt(hourStr, 10);
  const minutes = parseInt(minuteStr, 10);
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12 || 12;
  const formattedMinutes = minutes < 10 ? '0' + minutes : minutes;
  return `${hours}:${formattedMinutes} ${ampm}`;
}
  
  function getSlotRanges(doctorSlots) {
    const days = Object.keys(doctorSlots.DoctorSlots);
    const DaysWiseSLots = {
      '1': [],
      '2': [],
      '3': [],
      '4': [],
      '5': [],
      '6': [],
      '0': [],
    };
    days.forEach(day => {
      const daySlots = doctorSlots.DoctorSlots[day];
      if (daySlots.isSlotsAvailable) {
        for (let i = 1; i <= 3; i++) {
          const duration = daySlots[`duration${i}`];
          if(duration){
          const startTime =formatTime(duration?.startTime);
          const endTime = formatTime(duration?.endTime);
          const range = `${startTime} to ${endTime}`;
          if(startTime && endTime){
            DaysWiseSLots[day].push(range);
          }
        }
        }
      }
    });
    return DaysWiseSLots;
  }
  
  export const formatDoctorSlots = (doctorSlots) => {
    const timeRanges = getSlotRanges(doctorSlots);
    return timeRanges;
  }
 